// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `photo-only {
  width: 100%;
}
photo-only .thumbnail {
  margin-top: 5px;
  border: 2px solid red;
  width: 100%;
  height: auto;
  max-width: 100%;
  background-color: white;
}
photo-only .self-center {
  display: flex;
  flex-direction: column;
  justify-content: center;
}
photo-only .caption {
  margin: 0;
  padding: 5px 0 0 5px;
}

.image-upload > input {
  display: none;
}

@media only screen and (min-width: 768px) {
  .fullscreen-modal .modal-wrapper {
    position: absolute;
    top: 0;
    left: 0;
    margin: 5%;
    margin-top: 10%;
    display: block;
    width: 90%;
    height: 75%;
  }
}

.images-display {
  width: 100%;
}

.attachment-container {
  width: 50%;
  padding-left: 25px;
}

.image-container {
  position: relative;
  float: left;
  max-width: 250px;
  max-height: 250px;
  width: 100%;
  height: 100%;
}
.image-container img {
  max-height: 250px;
  height: 99%;
  width: 99%;
  padding: 1%;
}

.image-action-items {
  position: absolute;
  top: 5px;
  right: 5px;
  z-index: 9999;
}

.title {
  color: #000000;
  font-family: "Gotham-Bold";
  font-size: 1em;
  margin-left: 10px;
}

.title-edit {
  color: #000000;
  font-family: "Gotham-Bold";
  font-size: 1em;
}

.spacing {
  margin: 0.5em;
}

.photo-header {
  width: 100%;
}

.photo-buttons {
  float: right;
}`, "",{"version":3,"sources":["webpack://./src/components/photo/photo-only.scss"],"names":[],"mappings":"AAAA;EACE,WAAA;AACF;AACE;EACE,eAAA;EACA,qBAAA;EACA,WAAA;EACA,YAAA;EACA,eAAA;EACA,uBAAA;AACJ;AAEE;EACE,aAAA;EACA,sBAAA;EACA,uBAAA;AAAJ;AAGE;EACE,SAAA;EACA,oBAAA;AADJ;;AAKA;EACE,aAAA;AAFF;;AAOE;EACE;IACE,kBAAA;IACA,MAAA;IACA,OAAA;IACA,UAAA;IACA,eAAA;IACA,cAAA;IACA,UAAA;IACA,WAAA;EAJJ;AACF;;AAQA;EACE,WAAA;AALF;;AAQA;EACE,UAAA;EACA,kBAAA;AALF;;AAQA;EACE,kBAAA;EACA,WAAA;EACA,gBAAA;EACA,iBAAA;EACA,WAAA;EACA,YAAA;AALF;AAOE;EACE,iBAAA;EACA,WAAA;EACA,UAAA;EACA,WAAA;AALJ;;AASA;EACE,kBAAA;EACA,QAAA;EACA,UAAA;EACA,aAAA;AANF;;AASA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;EACA,iBAAA;AANF;;AASA;EACE,cAAA;EACA,0BAAA;EACA,cAAA;AANF;;AASA;EACE,aAAA;AANF;;AASA;EACE,WAAA;AANF;;AASA;EACE,YAAA;AANF","sourcesContent":["photo-only {\n  width: 100%;\n\n  .thumbnail {\n    margin-top: 5px;\n    border: 2px solid red;\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    background-color: white;\n  }\n\n  .self-center {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n  }\n\n  .caption {\n    margin: 0;\n    padding: 5px 0 0 5px;\n  }\n}\n\n.image-upload>input {\n  display: none;\n}\n\n\n.fullscreen-modal {\n  @media only screen and (min-width: 768px) {\n    .modal-wrapper {\n      position: absolute;\n      top: 0;\n      left: 0;\n      margin: 5%;\n      margin-top: 10%;\n      display: block;\n      width: 90%;\n      height: 75%;\n    }\n  }\n}\n\n.images-display {\n  width: 100%;\n}\n\n.attachment-container {\n  width: 50%;\n  padding-left: 25px;\n}\n\n.image-container {\n  position: relative;\n  float: left;\n  max-width: 250px;\n  max-height: 250px;\n  width: 100%;\n  height: 100%;\n\n  & img {\n    max-height: 250px;\n    height: 99%;\n    width: 99%;\n    padding: 1%;\n  }\n}\n\n.image-action-items {\n  position: absolute;\n  top: 5px;\n  right: 5px;\n  z-index: 9999;\n}\n\n.title {\n  color: #000000;\n  font-family: 'Gotham-Bold';\n  font-size: 1em;\n  margin-left: 10px;\n}\n\n.title-edit {\n  color: #000000;\n  font-family: 'Gotham-Bold';\n  font-size: 1em;\n}\n\n.spacing {\n  margin: 0.5em;\n}\n\n.photo-header {\n  width: 100%;\n}\n\n.photo-buttons {\n  float: right;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
